import { useState } from 'react'
import { Dialog, DialogTrigger } from '@/view/components/ui/dialog'
import { Button } from '@/view/components/ui/button'
import ListDocumentsModal from '../ListDocumentsModal'
import PersonalInfo from '../PersonalInfo'

export const ModalUploadFiles = () => {
  const [step, setStep] = useState<'listDocuments' | 'PersonalInfo'>(
    'listDocuments',
  )
  const [open, setOpen] = useState(false)

  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen)
    if (!isOpen) {
      // Reset step when closing? Or keep state? Usually reset.
      setTimeout(() => setStep('listDocuments'), 300)
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger className="w-full">
        <Button className="mt-4 w-full text-white">Anexar arquivos</Button>
      </DialogTrigger>

      {step === 'listDocuments' && (
        <ListDocumentsModal
          onBack={() => setOpen(false)}
          onContinue={() => setStep('PersonalInfo')}
        />
      )}

      {step === 'PersonalInfo' && (
        <PersonalInfo onBack={() => setStep('listDocuments')} />
      )}
    </Dialog>
  )
}
